export default __webpack_public_path__ + "static/megaVirtualGreen-094d9829beeb7d2274d165c0b9aa118b.jpg";